import { render, staticRenderFns } from "./PreparationFormList.vue?vue&type=template&id=b4e176f6&scoped=true"
import script from "./PreparationFormList.vue?vue&type=script&lang=js"
export * from "./PreparationFormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e176f6",
  null
  
)

export default component.exports